import { CommonModule } from '@angular/common';
import { NgModule, Type } from '@angular/core';
import { PageHeaderModule } from '@delon/abc/page-header';
import { SharedModule } from '@shared';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { SharedFeatureModule } from 'src/app/shared-feature';

import { ReportTabComponent } from '../../report-center/report-tab/report-tab.component';
import { StockFilterComponent } from './components/filter/stock-filter/stock-filter.component';
import { AgentRangeComponent } from './components/range/agent-range/agent-range.component';
import { SupplierAreaRangeComponent } from './components/range/ap-area-range/ap-area-range.component';
import { SupplierCategoryRangeComponent } from './components/range/ap-cate-range/ap-cate-range.component';
import { APCNRangeComponent } from './components/range/apcn-range/apcn-range.component';
import { APDNRangeComponent } from './components/range/apdn-range/apdn-range.component';
import { APPaymentRangeComponent } from './components/range/appv-range/appv-range.component';
import { APRefundRangeComponent } from './components/range/aprefund-range/aprefund-range.component';
import { CustomerAreaRangeComponent } from './components/range/ar-area-range/ar-area-range.component';
import { CustomerCategoryRangeComponent } from './components/range/ar-cate-range/ar-cate-range.component';
import { ARCNRangeComponent } from './components/range/arcn-range/arcn-range.component';
import { ARDNRangeComponent } from './components/range/ardn-range/ardn-range.component';
import { AreaRangeComponent } from './components/range/area-range/area-range.component';
import { ARReceiptRangeComponent } from './components/range/aror-range/aror-range.component';
import { ARRefundRangeComponent } from './components/range/arrefund-range/arrefund-range.component';
import { BillRangeComponent } from './components/range/bill-range/bill-range.component';
import { BirClassRangeComponent } from './components/range/bir-class-range/bir-class-range.component';
import { BirSupplierClassRangeComponent } from './components/range/bir-class-range/supplier/bir-supplier-class-range.component';
import { CCACRangeComponent } from './components/range/ccac-range/ccac-range.component';
import { CpRangeComponent } from './components/range/cp-range/cp-range.component';
import { CpRefundRangeComponent } from './components/range/cpr-range/cpr-range.component';
import { CsRangeComponent } from './components/range/cs-range/cs-range.component';
import { CsRefundRangeComponent } from './components/range/csr-range/csr-range.component';
import { CurrencyRangeComponent } from './components/range/currency-range/currency-range.component';
import { CustomerRangeComponent } from './components/range/customer-range/customer-range.component';
import { DACRangeComponent } from './components/range/dac-range/dac-range.component';
import { DateRangeComponent } from './components/range/date-range/date-range.component';
import { DoRangeComponent } from './components/range/do-range/do-range.component';
import { EInvInquiryDateRangeComponent } from './components/range/einv-inquiry-date-range/einv-inquiry-date-range.component';
import { FixedAssetsRangeComponent } from './components/range/fa-range/fa-range.component';
import { GlAccountRangeComponent } from './components/range/gl-range/glaccount-range.component';
import { GRNRangeComponent } from './components/range/grn-range/grn-range.component';
import { InvoiceRangeComponent } from './components/range/invoice-range/invoice-range.component';
import { JournalRangeComponent } from './components/range/journal-range/journal-range.component';
import { PaymentRangeComponent } from './components/range/payment-range/payment-range.component';
import { PaymentRefRangeComponent } from './components/range/paymentref-range/paymentref-range.component';
import { PcnRangeComponent } from './components/range/pcn-range/pcn-range.component';
import { PdnRangeComponent } from './components/range/pdn-range/pdn-range.component';
import { PINVRangeComponent } from './components/range/pinv-range/pinv-range.component';
import { PoRangeComponent } from './components/range/po-range/po-range.component';
import { PRRangeComponent } from './components/range/pr-range/pr-range.component';
import { ProjectRangeComponent } from './components/range/project-range/project-range.component';
import { PurchaserRangeComponent } from './components/range/purchaser-range/purchaser-range.component';
import { QtRangeComponent } from './components/range/qt-range/qt-range.component';
import { ReceiptRangeComponent } from './components/range/receipt-range/receipt-range.component';
import { ReceiptRefRangeComponent } from './components/range/receiptref-range/receiptref-range.component';
import { SCNRangeComponent } from './components/range/scn-range/scn-range.component';
import { SDNRangeComponent } from './components/range/sdn-range/sdn-range.component';
import { SINVRangeComponent } from './components/range/sinv-range/sinv-range.component';
import { SoRangeComponent } from './components/range/so-range/so-range.component';
import { StockAccountPresetsRangeComponent } from './components/range/stk-account-presets-range/stk-account-presets-range.component';
import { StockAdjustmentRangeComponent } from './components/range/stock-adj-range/stock-adj-range.component';
import { StockCategoryRangeComponent } from './components/range/stock-cate-range/stock-cate-range.component';
import { StockClassRangeComponent } from './components/range/stock-class-range/stock-class-range.component';
import { StockGroupRangeComponent } from './components/range/stock-group-range/stock-group-range.component';
import { StockInRangeComponent } from './components/range/stock-in-range/stock-in-range.component';
import { StockItemsRangeComponent } from './components/range/stock-item-range/stock-item-range.component';
import { StockLocationRangeComponent } from './components/range/stock-location-range/stock-location-range.component';
import { StockOpeningBalanceRangeComponent } from './components/range/stock-ob-range/stock-ob-range.component';
import { StockOutRangeComponent } from './components/range/stock-out-range/stock-out-range.component';
import { StockTransferRangeComponent } from './components/range/stock-transfer-range/stock-transfer-range.component';
import { SupplierRangeComponent } from './components/range/supplier-range/supplier-range.component';
import { TermRangeComponent } from './components/range/term-range/term-range.component';
import { ReportCloneComponent } from './components/report-clone/report-clone.component';
import { ReportHeaderComponent } from './components/report-header/report-header.component';
import { ReportTasksComponent } from './components/report-tasks/report-tasks.component';
import { AccountantSelectComponent } from './components/select/accountant-select/accountant-select.component';
import { APPaymentSelectComponent } from './components/select/appv-select/appv-select.component';
import { ARReceiptSelectComponent } from './components/select/aror-select/aror-select.component';
import { DealerSelectComponent } from './components/select/dealer-select/dealer-select.component';
import { DocTypeSelectComponent } from './components/select/doctype-select/doctype-select.component';
import { PaymentRefSelectComponent } from './components/select/paymentsref-select/paymentref-select.component';
import { ProductSelectComponent } from './components/select/product-select/product-select.component';
import { ProjectFilterSelectComponent } from './components/select/project-filter-select/project-filter-select.component';
import { ProjectOptionRadioComponent } from './components/select/project-option-radio/project-option-radio.component';
import { ReceiptRefSelectComponent } from './components/select/receiptref-select/receiptref-select.component';
import { SalesPersonSelectComponent } from './components/select/sales-person-select/sales-person-select.component';
import { SSTReturnSelectComponent } from './components/select/sstreturn-select/sstreturn-select.component';
import { StockLocationMultiSelectComponent } from './components/select/stock-location-multi-select/stock-location-multi-select.component';
import { StockMultiLocationSelectComponent } from './components/select/stock-multi-location-select/stock-multi-location-select.component';

// #endregion
// #region your componets & directives

const STANDALONE_COMPONENTS: Array<Type<void>> = [
  ReportCloneComponent,
  ReportHeaderComponent,
  ReportTasksComponent,
  ProjectFilterSelectComponent,
  ProjectOptionRadioComponent,
  DateRangeComponent
];

const COMPONENTS: Array<Type<void>> = [
  AreaRangeComponent,
  CustomerRangeComponent,
  SupplierRangeComponent,
  DACRangeComponent,
  CCACRangeComponent,
  InvoiceRangeComponent,
  ARDNRangeComponent,
  ARCNRangeComponent,
  PurchaserRangeComponent,
  BillRangeComponent,
  APDNRangeComponent,
  APCNRangeComponent,
  ReceiptRangeComponent,
  PaymentRangeComponent,
  JournalRangeComponent,
  SINVRangeComponent,
  CustomerCategoryRangeComponent,
  SupplierCategoryRangeComponent,
  AgentRangeComponent,
  ProjectRangeComponent,
  SSTReturnSelectComponent,
  ReceiptRefSelectComponent,
  ReceiptRefRangeComponent,
  PaymentRefSelectComponent,
  PaymentRefRangeComponent,
  GlAccountRangeComponent,
  TermRangeComponent,
  CustomerAreaRangeComponent,
  ARReceiptSelectComponent,
  ARReceiptRangeComponent,
  CurrencyRangeComponent,
  SupplierAreaRangeComponent,
  APPaymentSelectComponent,
  APPaymentRangeComponent,
  QtRangeComponent,
  SoRangeComponent,
  DoRangeComponent,
  CsRangeComponent,
  CpRefundRangeComponent,
  BirClassRangeComponent,
  StockItemsRangeComponent,
  StockCategoryRangeComponent,
  StockGroupRangeComponent,
  StockClassRangeComponent,
  StockLocationRangeComponent,
  StockAdjustmentRangeComponent,
  StockOpeningBalanceRangeComponent,
  DocTypeSelectComponent,
  PoRangeComponent,
  PdnRangeComponent,
  PINVRangeComponent,
  CpRangeComponent,
  StockAccountPresetsRangeComponent,
  PRRangeComponent,
  GRNRangeComponent,
  PcnRangeComponent,
  SCNRangeComponent,
  SDNRangeComponent,
  ARRefundRangeComponent,
  APRefundRangeComponent,
  EInvInquiryDateRangeComponent,
  StockLocationMultiSelectComponent,
  CsRefundRangeComponent,
  StockMultiLocationSelectComponent,
  StockTransferRangeComponent,
  StockFilterComponent,
  StockInRangeComponent,
  StockOutRangeComponent,
  AccountantSelectComponent,
  DealerSelectComponent,
  ProductSelectComponent,
  FixedAssetsRangeComponent,
  SalesPersonSelectComponent,
  BirSupplierClassRangeComponent
];

// #endregion
const THIRDMODULES: Array<Type<void>> = [
  NzIconModule,
  NzSpaceModule,
  PageHeaderModule,
  NzBreadCrumbModule,
  NzRadioModule,
  NzDatePickerModule,
  NzInputNumberModule
];

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    SharedFeatureModule,
    ...STANDALONE_COMPONENTS,
    ...THIRDMODULES
  ],
  declarations: [
    // your components
    ...COMPONENTS
  ],
  exports: [
    SharedModule,
    SharedFeatureModule,
    ...THIRDMODULES,
    ...COMPONENTS,
    ...STANDALONE_COMPONENTS
  ]
})
export class ReportSharedModule {}
